import { DataHeader, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutZipZone extends Layout {
    dataheaderDispatchZone: DataHeader;
    panelZipZone: Panel;
    sourceZipzone: DataSource;
    textbMarketAreaId: Textbox;
    textboxCity: Textbox;
    textboxEmptyDistanceOverride: Textbox;
    textboxState: Textbox;
    textboxZipCodeThreeDigit: Textbox;
    textboxZone: Textbox;
}
